import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onBeforeMount, ref, watch } from 'vue'

import { useAssetCache } from '@/popup/compositions/useAssetCache'

type Props = {
  name: string
  fill?: string
  stroke?: string
  dataTestid?: string
  color?: string
  height?: string
  width?: string
  strokeWidth?: string
  secondaryColor?: string
}

type Emits = {
  (event: 'click', value: unknown): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'Skeleton',
  props: {
    name: {},
    fill: { default: undefined },
    stroke: { default: undefined },
    dataTestid: { default: 'svg-icon' },
    color: { default: '#DEE7ED' },
    height: { default: '24' },
    width: { default: '24' },
    strokeWidth: { default: '1.5' },
    secondaryColor: { default: 'var(--neutral-100)' }
  },
  emits: ["click"],
  setup(__props: any, { emit: __emit }) {

const emits = __emit
const onClick = (val: unknown) => {
  emits('click', val)
}
const props = __props

const skeletonComponent = ref<any>()

const loadAsset = (iconName: string) => {
  const { getAsset } = useAssetCache()
  getAsset(iconName).then((module: any) => {
    skeletonComponent.value = module
  })
}

onBeforeMount(() => {
  loadAsset(props.name)
})

const iconName = computed(() => props.name)
watch(iconName, (newValue, oldValue) => {
  if (newValue !== oldValue) {
    loadAsset(newValue)
  }
})

const attributes: { [k in string]: string | undefined } = {
  'data-testid': props.dataTestid,
  fill:
    props.fill &&
    getComputedStyle(document.documentElement).getPropertyValue(props.fill),
  color: props.color,
  width: props.width,
  height: props.height,
  stroke:
    props.stroke &&
    getComputedStyle(document.documentElement).getPropertyValue(props.stroke),
  strokeWidth: props.strokeWidth,
  secondaryColor: props.secondaryColor,
}
for (const key of Object.keys(attributes)) {
  if (attributes[key] === undefined) {
    delete attributes[key]
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(skeletonComponent.value || 'svg'), _mergeProps({
    role: "img",
    class: "svg-icon loading-skeleton"
  }, attributes, { onClick: onClick }), null, 16 /* FULL_PROPS */))
}
}

})